module.exports = __webpack_public_path__ + "img/sort-solid.031c599.svg";